import type { ScreenModule } from "../../../app/screen-module";
import { AgentEditPage } from "../pages";

export default {
	id: "system-admin.agent-edit",
	path: "/system/agents/:agentId",
	area: "system-admin",
	label: "Agent編集",
	roles: ["platform_admin", "platform_viewer"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: AgentEditPage,
} satisfies ScreenModule;
